import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import * as CanvasJS from '../../../assets/canvasjs.min';
import { AstrolyticsService } from "../../_services/astrolytics.service";
import { AuthenticationService } from "../../_services/authentication.service";
import { Subscription } from 'rxjs'
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-my-sales-page',
  templateUrl: './my-sales-page.component.html',
  styleUrls: ['./my-sales-page.component.css']
})
export class MySalesPageComponent implements OnInit, AfterViewInit, OnDestroy {
  monthlySalesSubscription: Subscription;
  errorSubscription: Subscription;

  salesData;
  loading;
  chartError;
  emptyChart;

  constructor( private router: Router, private astrolyticsService: AstrolyticsService, private authenticationService: AuthenticationService) {
    this.router.navigate(['/']);
  }

  ngOnInit() {    
    this.loading = true;
    this.chartError = false;
    this.emptyChart = false;
  }

  ngAfterViewInit(){
    this.monthlySalesSubscription = this.astrolyticsService.monthlySalesObservable.subscribe(message => {
      if (message.graph_data) {
        
        if (message.graph_data.length == 0) {
          this.emptyChart = true;
        } else {
          message["graph_data"].forEach(category => {
            category["dataPoints"].forEach(dataPoint => {
              dataPoint["x"] = new Date(dataPoint["x"])
            });
          });
          let chart = new CanvasJS.Chart("chartContainer", {
            animationEnabled: true,
            exportEnabled: true,
            axisY: {
              valueFormatString: "$#,##0 UYU",
              title: "Ingresos"
            },
            tooltip:{
              shared: true
            },
            legend:{
              cursor: "pointer",
              fontSize: 16,
              itemclick: this.toggleDataSeries
            },
            data: message["graph_data"]
          });
          setTimeout(() => {
            this.loading = false;
            chart.render();
          });
        }
      }
    });

    this.errorSubscription = this.astrolyticsService.errorObservable.subscribe(message => {
      if (message) {
        this.loading = false;
        this.chartError = true;
      }
    });

    this.astrolyticsService.getMonthlySales(this.authenticationService.selectedStoreValue.id);
  }

  ngOnDestroy() {
    this.monthlySalesSubscription.unsubscribe();
    this.errorSubscription.unsubscribe();
  }

  toggleDataSeries(e){
    if (typeof(e.dataSeries.visible) === "undefined" || e.dataSeries.visible) {
      e.dataSeries.visible = false;
    }
    else{
      e.dataSeries.visible = true;
    }
    e.chart.render();
  }
}
